import React, { useState, useEffect } from "react";
import { Routes, Route, Link } from "react-router-dom";
import { Grid, Card, CardContent, CardActions, Button, IconButton, Tooltip, Paper, Box } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from "axios";
import Img1 from "./HelpImages/1.png";
import Img2 from "./HelpImages/2.png";
import Img3 from "./HelpImages/3.png";
import Img4 from "./HelpImages/4.png";
import Img5 from "./HelpImages/5.png";
import Img6 from "./HelpImages/6.png";
import Img7 from "./HelpImages/7.png";
import Img8 from "./HelpImages/8.png";
import Img9 from "./HelpImages/9.png";
import Img10 from "./HelpImages/10.png";
import Img11 from "./HelpImages/11.png";
import Img12 from "./HelpImages/12.png";
import Img13 from "./HelpImages/13.png";

export default function Help() {
  const fetchData = async () => {
    let response = await axios.get(`/api/approvals`);
    console.log(response)
    // if (response.data.error) {
    //     navigate(`/login`, { replace: false })
    // }
  }

  return (
    <>
      <div style={{ margin: 30 }}>
        <h2>Help</h2>
        <p>Click on any of the titles listed below to see documentation regarding their usage.</p>
      </div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Menu View</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>1. Dropdown menu</strong></p>
              <p>To access the menu, click on the menu icon, which is located to the far right at the top.</p>
              <img src={Img1} style={{ width: "100%", maxWidth: "500px" }} />
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>2. Dropdown menu items</strong></p>
              <p>The main views of interest are Timesheets, Vacation Status and Absence.</p>
              <img src={Img8} style={{ width: "100%", maxWidth: "600px" }} />
            </Box>
          </Box>
          <br />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Timesheets Overview</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>1. Color indicators</strong></p>
              <p>In the timesheets view, the colors incidate whether the timesheet has been submitted or not.</p>
              <img src={Img2} style={{ width: "100%", maxWidth: "600px" }} />
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>2. Create a New Week</strong></p>
              <p>To create a new week, click on the floating button with a plus icon in the bottom corner.</p>
              <img src={Img3} style={{ width: "100%", maxWidth: "600px" }} />
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>3. Confirm New Week</strong></p>
              <p>After clicking on the floating button with a plus icon in the bottom corner, a date picker dialog will open. To finish creating a timesheet for a new week, select a date and press OK.</p>
              <img src={Img4} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography>Single timesheet view</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>1. New Timesheet</strong></p>
              <p>This is how a newly created timesheet looks like, before any hours are registered.</p>
              <img src={Img5} style={{ width: "100%", maxWidth: "350px" }} />
              <ul>
                <li style={{ marginBottom: 8 }}>To register new hours, click the green plus icon in the bottom right corner.</li>
                <li style={{ marginBottom: 8 }}>To travel between timesheets, click the gray arrow icons in the right bottom corner.</li>
                <li>To duplicate a timesheet, to delete it, to submit it, or to add template entries to it, click (or hover) on the blue button with three vertical dots in the lower right corner.</li>
              </ul>
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>2. Add New Entry to Timesheet</strong></p>
              <p>Please finish enterring hours for the new entry and then click on the Save button.</p>
              <img src={Img6} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>3. After New Entry Has Been Added</strong></p>
              <p>After adding a new entry, this is how the timesheet view appears.</p>
              <img src={Img7} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>4. Editing a Line</strong></p>
              <p>After clicking on a line, this pop-up modal appears. To edit the information, click on the edit button.</p>
              <img src={Img9} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography>Absence View</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>1. Absence Overview</strong></p>
              <p>On the top of the absence page, you are presented with an overview matrix.</p>
              <img src={Img10} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>2. Inspect Absence Line</strong></p>
              <p>To view further information on registered absence, click on the corresponding line. A pop-up dialog will then open with information pertaining to the registered absence.</p>
              <img src={Img11} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography>Vacation View</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>1. Vacation Overview</strong></p>
              <p>On the top of the vacation status page, you are shown your vacation status.</p>
              <img src={Img12} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
          <br />
          <Box sx={{ border: 1, borderRadius: 1 }}>
            <Box sx={{ width: "96%", marginLeft: "2%" }}>
              <p><strong>2. Inspect Vacation Line</strong></p>
              <p>To view further information on a registered vacation line, click on the corresponding line. A pop-up dialog will then open with information you have registered.</p>
              <img src={Img13} style={{ width: "100%", maxWidth: "350px" }} />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}